import { ArrowBack } from "@mui/icons-material";
import {
    Box,
    Button,
    CircularProgress,
    Container,
    IconButton,
    TextField,
    Typography,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const ResetPasswordContainerContent = ({ children }) => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                }}
            >
                <Box sx={{ width: "100%" }}>
                    <IconButton
                        title="voltar"
                        edge="end"
                        aria-label="edit"
                        onClick={() => navigate("/")}
                    >
                        <ArrowBack />
                    </IconButton>
                </Box>
                <Typography variant="h4" gutterBottom>
                    Redefinir Senha
                </Typography>

                {children}
            </Box>
        </Container>
    );
};

const ResetPasswordPage = () => {
    const backendEndpoint = process.env.REACT_APP_BACKEND_ENDPOINT;

    const { token } = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [isTokenValid, setIsTokenValid] = useState(null);
    const [password, setPassword] = useState("");
    const [passwordRepeat, setPasswordRepeat] = useState("");
    const [validate, setValidate] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const validateToken = useCallback(
        async (tokenValue) => {
            const response = await fetch(
                `${backendEndpoint}/forgot_password/${tokenValue}/`,
                {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                },
            );
            const responseBody = await response.json();
            setIsTokenValid(responseBody.valid);
        },
        [backendEndpoint],
    );

    useEffect(() => {
        if (!token) return;

        validateToken(token);
    }, [token, validateToken]);

    const cleanValidations = () => {
        setValidate(false);
        setError(false);
        setErrorMessage("");
    };

    const handleResetPassword = () => {
        setValidate(true);

        if (
            password === "" ||
            passwordRepeat === "" ||
            password !== passwordRepeat
        ) {
            return;
        }

        setValidate(true);
        setIsLoading(true);
        fetch(`${backendEndpoint}/forgot_password/${token}/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                newPassword: password,
            }),
        })
            .then(async (response) => {
                if (response.ok) {
                    const result = await response.json();
                    return result;
                } else {
                    const result = await response.json();
                    throw new Error(result.detail);
                }
            })
            .then(() => {
                setIsLoading(false);
                navigate("/");
            })
            .catch((error) => {
                setErrorMessage(`${error}`.replace("Error: ", ""));
                setIsLoading(false);
            });
    };

    if (isTokenValid === null) {
        return (
            <ResetPasswordContainerContent>
                <CircularProgress size="16px" color="inherit" />
            </ResetPasswordContainerContent>
        );
    }

    return (
        <ResetPasswordContainerContent>
            {isTokenValid ? (
                <>
                    <TextField
                        value={password}
                        onChange={(e) => {
                            setPassword(e.target.value);
                            cleanValidations();
                        }}
                        label="Sua nova senha"
                        type="password"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        error={validate && password === "" ? true : false}
                        helperText={
                            validate && password === ""
                                ? "Preencha sua senha"
                                : ""
                        }
                    />

                    <TextField
                        value={passwordRepeat}
                        onChange={(e) => {
                            setPasswordRepeat(e.target.value);
                            cleanValidations();
                        }}
                        label="Repita sua nova senha"
                        type="password"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        error={
                            validate &&
                            (passwordRepeat === "" ||
                                passwordRepeat !== password)
                                ? true
                                : false
                        }
                        helperText={
                            validate &&
                            (passwordRepeat === "" ||
                                passwordRepeat !== password)
                                ? "Repita sua senha corretamente"
                                : ""
                        }
                    />

                    {error ? (
                        <Typography variant="h6">{errorMessage}</Typography>
                    ) : null}

                    <Button
                        variant="contained"
                        color="primary"
                        sx={{ marginTop: 2 }}
                        fullWidth
                        startIcon={
                            isLoading ? (
                                <CircularProgress size="16px" color="inherit" />
                            ) : undefined
                        }
                        onClick={handleResetPassword}
                    >
                        Enviar
                    </Button>
                </>
            ) : (
                <Typography variant="h6" textAlign="center" marginTop="48px">
                    O link expirou ou é inválido.
                </Typography>
            )}
        </ResetPasswordContainerContent>
    );
};

export default ResetPasswordPage;
